import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "DocumentCard" }
const _hoisted_2 = { class: "DocumentCard__header" }
const _hoisted_3 = { class: "DocumentCard__slug" }
const _hoisted_4 = { class: "DocumentCard__client" }
const _hoisted_5 = { class: "DocumentCard__title" }
const _hoisted_6 = { class: "DocumentCard__status" }

import { PropType, computed } from "vue";
import Logo from "@/components/general/Logo.vue";
import DocumentSlug from "./DocumentSlug.vue";
import PaidStatus from "./PaidStatus.vue";
import { Document } from "@/types";

import { useDocumentsStore } from "@/stores/documents";
import MailSent from "@/components/pages/documents/card/MailSent.vue";
import DocumentOnDrive from "@/components/pages/documents/card/DocumentOnDrive.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentCard',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const documentsStore = useDocumentsStore();

const clientName = computed(() => {
    const client = documentsStore.getClientForDocument(props.document);
    return client ? client.name : "";
});

const hasMailSent = computed(() => {
    return props.document.mails.find((m) => m.sent) !== undefined;
});

const hasDocumentOnDrive = computed(() => {
    return (
        props.document.google_drive_id !== 0 &&
        props.document.google_drive_id !== null
    );
});

console.log(props.document);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Logo, { size: 3 }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(DocumentSlug, { document: __props.document }, null, 8, ["document"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(clientName.value), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(__props.document.title), 1),
    _createElementVNode("div", _hoisted_6, [
      (hasMailSent.value)
        ? (_openBlock(), _createBlock(MailSent, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(PaidStatus, { document: __props.document }, null, 8, ["document"])
    ])
  ]))
}
}

})